import { StoreService } from "@3gaam/api/services";
import {
  RateUserProductInput,
  RateUserProductOutput,
  SkipRateUserProductsInput,
  SkipRateUserProductsOutput,
} from "@3gaam/api/types/store";
import successImage from "@3gaam/shared/assets/images/illustrations/success.png";
import successImage2x from "@3gaam/shared/assets/images/illustrations/success@2x.png";
import { RawResponsiveModal } from "@3gaam/shared/components/general/responsiveModal";
import { Space } from "@3gaam/shared/components/general/space";
import Image from "@3gaam/shared/components/image";
import { useMutation } from "@3gaam/shared/hooks/useMutation";
import React, { useCallback, useEffect, useState } from "react";
import { useHallActions } from "../../useActionStore";
import SecondaryLayout, { PromotionRenderType } from "../layout/SecondaryLayout";
import { ModalsType, useModal } from "../modals/useModalStore";
import { RatingForm } from "./RatingForm";

const RatingModal = () => {
  const [submitted, setSubmit] = useState<boolean>(false);

  let {
    actionHandlers: { goToCounselorPage },
  } = useHallActions();

  const { getActiveModal, closeModal } = useModal();
  let payload = getActiveModal("rating") as ModalsType["rating"] | undefined;

  let [
    {
      isRequesting: skipRateUserProductsRequesting,
      data: skipRateUserProductsData,
    },
    skipRateUserProducts,
  ] = useMutation<SkipRateUserProductsOutput, SkipRateUserProductsInput>(
    "SkipRateUserProducts",
    StoreService.skipRateUserProducts,
  );

  let [
    { isRequesting: rateUserProductRequesting, data: rateUserProductData },
    rateUserProduct,
  ] = useMutation<RateUserProductOutput, RateUserProductInput>(
    "rateUserProduct",
    StoreService.rateUserProduct,
  );

  let onClose = useCallback(() => {
    closeModal();
  }, [closeModal]);

  const onDismiss = useCallback(() => {
    skipRateUserProducts({});
  }, [skipRateUserProducts]);

  const onSubmit = useCallback(
    ({ rate, comment }: { rate: number; comment: string | undefined }) => {
      if (rateUserProductRequesting) return;
      let counselorId = payload?.productFeedback.Counselor?.CounselorId;
      let userProductId = payload?.productFeedback.UserProductId;
      if (!counselorId) return;
      let variables: RateUserProductInput = {
        Rate: rate,
        Comment: comment || null,
        CounselorId: counselorId,
        RatedQuantity: payload?.productFeedback.RatedQuantity,
        AppointmentId: payload?.productFeedback.AppointmentId,
        UserProductId: userProductId,
      };
      rateUserProduct(variables);
    },
    [payload?.productFeedback, rateUserProduct, rateUserProductRequesting],
  );

  useEffect(() => {
    if (rateUserProductRequesting) return;
    if (!rateUserProductData) return;
    setSubmit(true);
  }, [rateUserProductData, rateUserProductRequesting]);

  if (!payload) return <></>;

  let show = !!payload;
  const productFeedback = payload.productFeedback;
  const counselor = productFeedback.Counselor;

  return (
    <RawResponsiveModal show={show} onClose={onClose}>
      <SecondaryLayout onClose={onClose} title="ثبت نظر" promotionRenderType={PromotionRenderType.None}>
        <div className="d-flex flex-column bg-lightgray h-100">
          {submitted ? (
            <>
              <div className="d-flex flex-grow-1 flex-column align-items-center justify-content-center">
                <div
                  className="mx-auto"
                  style={{ width: 200 }}
                  onClick={() => {
                    if (!productFeedback?.Counselor?.Slug) return;
                    goToCounselorPage(productFeedback.Counselor.Slug);
                  }}
                >
                  <Image src={successImage} srcSet={`${successImage2x} 2x`} />
                </div>
                <Space vertical={24} />
                <div className="text-center">
                  <span className="text-dark-gray font-20">
                    نظر شما با موفقیت ثبت شد
                  </span>
                  <p className="font-16 text-gray3 font-weight-light">
                    از همکاری شما متشکریم
                  </p>
                </div>
              </div>
              <div className="p-3">
                <button
                  type="submit"
                  className={`btn btn-primary w-100 font-18`}
                  onClick={() => {
                    onClose();
                  }}
                >
                  باشه
                </button>
              </div>
            </>
          ) : (
            <RatingForm
              onDismiss={() => {
                onDismiss();
                onClose();
              }}
              onSubmit={onSubmit}
              productFeedback={productFeedback}
              rateUserProductRequesting={rateUserProductRequesting}
            />
          )}
        </div>
      </SecondaryLayout>
    </RawResponsiveModal>
  );
};

export default React.memo(RatingModal);
